const countries = [
    {
        isoCode: 'AF',
        name: 'Afghanistan',
    },
    {
        isoCode: 'ZA',
        name: 'Afrique du Sud',
    },
    {
        isoCode: 'AL',
        name: 'Albanie',
    },
    {
        isoCode: 'DZ',
        name: 'Algérie',
    },
    {
        isoCode: 'DE',
        name: 'Allemagne',
    },
    {
        isoCode: 'AD',
        name: 'Andorre',
    },
    {
        isoCode: 'AO',
        name: 'Angola',
    },
    {
        isoCode: 'AI',
        name: 'Anguilla',
    },
    {
        isoCode: 'AG',
        name: 'Antigua-et-Barbuda',
    },
    {
        isoCode: 'SA',
        name: 'Arabie saoudite',
    },
    {
        isoCode: 'AR',
        name: 'Argentine',
    },
    {
        isoCode: 'AM',
        name: 'Arménie',
    },
    {
        isoCode: 'AW',
        name: 'Aruba',
    },
    {
        isoCode: 'AU',
        name: 'Australie',
    },
    {
        isoCode: 'AT',
        name: 'Autriche',
    },
    {
        isoCode: 'AZ',
        name: 'Azerbaïdjan',
    },
    {
        isoCode: 'BS',
        name: 'Bahamas',
    },
    {
        isoCode: 'BH',
        name: 'Bahreïn',
    },
    {
        isoCode: 'BD',
        name: 'Bangladesh',
    },
    {
        isoCode: 'BB',
        name: 'Barbade',
    },
    {
        isoCode: 'BE',
        name: 'Belgique',
    },
    {
        isoCode: 'BZ',
        name: 'Belize',
    },
    {
        isoCode: 'BJ',
        name: 'Bénin',
    },
    {
        isoCode: 'BM',
        name: 'Bermudes',
    },
    {
        isoCode: 'BT',
        name: 'Bhoutan',
    },
    {
        isoCode: 'BY',
        name: 'Biélorussie',
    },
    {
        isoCode: 'BO',
        name: 'Bolivie',
    },
    {
        isoCode: 'BA',
        name: 'Bosnie-Herzégovine',
    },
    {
        isoCode: 'BW',
        name: 'Botswana',
    },
    {
        isoCode: 'BR',
        name: 'Brésil',
    },
    {
        isoCode: 'BN',
        name: 'Brunei',
    },
    {
        isoCode: 'BG',
        name: 'Bulgarie',
    },
    {
        isoCode: 'BF',
        name: 'Burkina Faso',
    },
    {
        isoCode: 'BI',
        name: 'Burundi',
    },
    {
        isoCode: 'KH',
        name: 'Cambodge',
    },
    {
        isoCode: 'CM',
        name: 'Cameroun',
    },
    {
        isoCode: 'CA',
        name: 'Canada',
    },
    {
        isoCode: 'CV',
        name: 'Cap-Vert',
    },
    {
        isoCode: 'CL',
        name: 'Chili',
    },
    {
        isoCode: 'CN',
        name: 'Chine',
    },
    {
        isoCode: 'CY',
        name: 'Chypre',
    },
    {
        isoCode: 'CO',
        name: 'Colombie',
    },
    {
        isoCode: 'KM',
        name: 'Comores',
    },
    {
        isoCode: 'CG',
        name: 'Congo-Brazzaville',
    },
    {
        isoCode: 'CD',
        name: 'Congo-Kinshasa',
    },
    {
        isoCode: 'KR',
        name: 'Corée du Sud',
    },
    {
        isoCode: 'CR',
        name: 'Costa Rica',
    },
    {
        isoCode: 'HR',
        name: 'Croatie',
    },
    {
        isoCode: 'CW',
        name: 'Curaçao',
    },
    {
        isoCode: 'CI',
        name: 'Côte d’Ivoire',
    },
    {
        isoCode: 'DK',
        name: 'Danemark',
    },
    {
        isoCode: 'DJ',
        name: 'Djibouti',
    },
    {
        isoCode: 'DM',
        name: 'Dominique',
    },
    {
        isoCode: 'EG',
        name: 'Égypte',
    },
    {
        isoCode: 'AE',
        name: 'Émirats arabes unis',
    },
    {
        isoCode: 'EC',
        name: 'Équateur',
    },
    {
        isoCode: 'ER',
        name: 'Érythrée',
    },
    {
        isoCode: 'ES',
        name: 'Espagne',
    },
    {
        isoCode: 'EE',
        name: 'Estonie',
    },
    {
        isoCode: 'SZ',
        name: 'Eswatini',
    },
    {
        isoCode: 'VA',
        name: 'État de la Cité du Vatican',
    },
    {
        isoCode: 'US',
        name: 'États-Unis',
    },
    {
        isoCode: 'ET',
        name: 'Éthiopie',
    },
    {
        isoCode: 'FJ',
        name: 'Fidji',
    },
    {
        isoCode: 'FI',
        name: 'Finlande',
    },
    {
        isoCode: 'FR',
        name: 'France Métropolitaine',
    },
    {
        isoCode: 'GA',
        name: 'Gabon',
    },
    {
        isoCode: 'GM',
        name: 'Gambie',
    },
    {
        isoCode: 'GE',
        name: 'Géorgie',
    },
    {
        isoCode: 'GS',
        name: 'Géorgie du Sud-et-les Îles Sandwich du Sud',
    },
    {
        isoCode: 'GH',
        name: 'Ghana',
    },
    {
        isoCode: 'GI',
        name: 'Gibraltar',
    },
    {
        isoCode: 'GR',
        name: 'Grèce',
    },
    {
        isoCode: 'GD',
        name: 'Grenade',
    },
    {
        isoCode: 'GL',
        name: 'Groenland',
    },
    {
        isoCode: 'GP',
        name: 'Guadeloupe',
    },
    {
        isoCode: 'GT',
        name: 'Guatemala',
    },
    {
        isoCode: 'GG',
        name: 'Guernesey',
    },
    {
        isoCode: 'GN',
        name: 'Guinée',
    },
    {
        isoCode: 'GQ',
        name: 'Guinée équatoriale',
    },
    {
        isoCode: 'GW',
        name: 'Guinée-Bissau',
    },
    {
        isoCode: 'GY',
        name: 'Guyana',
    },
    {
        isoCode: 'GF',
        name: 'Guyane française',
    },
    {
        isoCode: 'HT',
        name: 'Haïti',
    },
    {
        isoCode: 'HN',
        name: 'Honduras',
    },
    {
        isoCode: 'HU',
        name: 'Hongrie',
    },
    {
        isoCode: 'CX',
        name: 'Île Christmas',
    },
    {
        isoCode: 'NF',
        name: 'Île Norfolk',
    },
    {
        isoCode: 'IM',
        name: 'Île de Man',
    },
    {
        isoCode: 'AX',
        name: 'Îles Åland',
    },
    {
        isoCode: 'KY',
        name: 'Îles Caïmans',
    },
    {
        isoCode: 'CC',
        name: 'Îles Cocos',
    },
    {
        isoCode: 'CK',
        name: 'Îles Cook',
    },
    {
        isoCode: 'FO',
        name: 'Îles Féroé',
    },
    {
        isoCode: 'FK',
        name: 'Îles Malouines',
    },
    {
        isoCode: 'PN',
        name: 'Îles Pitcairn',
    },
    {
        isoCode: 'SB',
        name: 'Îles Salomon',
    },
    {
        isoCode: 'TC',
        name: 'Îles Turques-et-Caïques',
    },
    {
        isoCode: 'VG',
        name: 'Îles Vierges britanniques',
    },
    {
        isoCode: 'UM',
        name: 'Îles mineures éloignées des États-Unis',
    },
    {
        isoCode: 'IN',
        name: 'Inde',
    },
    {
        isoCode: 'ID',
        name: 'Indonésie',
    },
    {
        isoCode: 'IQ',
        name: 'Irak',
    },
    {
        isoCode: 'IE',
        name: 'Irlande',
    },
    {
        isoCode: 'IS',
        name: 'Islande',
    },
    {
        isoCode: 'IL',
        name: 'Israël',
    },
    {
        isoCode: 'IT',
        name: 'Italie',
    },
    {
        isoCode: 'JM',
        name: 'Jamaïque',
    },
    {
        isoCode: 'JP',
        name: 'Japon',
    },
    {
        isoCode: 'JE',
        name: 'Jersey',
    },
    {
        isoCode: 'JO',
        name: 'Jordanie',
    },
    {
        isoCode: 'KZ',
        name: 'Kazakhstan',
    },
    {
        isoCode: 'KE',
        name: 'Kenya',
    },
    {
        isoCode: 'KG',
        name: 'Kirghizstan',
    },
    {
        isoCode: 'KI',
        name: 'Kiribati',
    },
    {
        isoCode: 'XK',
        name: 'Kosovo',
    },
    {
        isoCode: 'KW',
        name: 'Koweït',
    },
    {
        isoCode: 'RE',
        name: 'La Réunion',
    },
    {
        isoCode: 'LA',
        name: 'Laos',
    },
    {
        isoCode: 'LS',
        name: 'Lesotho',
    },
    {
        isoCode: 'LV',
        name: 'Lettonie',
    },
    {
        isoCode: 'LB',
        name: 'Liban',
    },
    {
        isoCode: 'LR',
        name: 'Liberia',
    },
    {
        isoCode: 'LY',
        name: 'Libye',
    },
    {
        isoCode: 'LI',
        name: 'Liechtenstein',
    },
    {
        isoCode: 'LT',
        name: 'Lituanie',
    },
    {
        isoCode: 'LU',
        name: 'Luxembourg',
    },
    {
        isoCode: 'MK',
        name: 'Macédoine du Nord',
    },
    {
        isoCode: 'MG',
        name: 'Madagascar',
    },
    {
        isoCode: 'MY',
        name: 'Malaisie',
    },
    {
        isoCode: 'MW',
        name: 'Malawi',
    },
    {
        isoCode: 'MV',
        name: 'Maldives',
    },
    {
        isoCode: 'ML',
        name: 'Mali',
    },
    {
        isoCode: 'MT',
        name: 'Malte',
    },
    {
        isoCode: 'MA',
        name: 'Maroc',
    },
    {
        isoCode: 'MQ',
        name: 'Martinique',
    },
    {
        isoCode: 'MU',
        name: 'Maurice',
    },
    {
        isoCode: 'MR',
        name: 'Mauritanie',
    },
    {
        isoCode: 'YT',
        name: 'Mayotte',
    },
    {
        isoCode: 'MX',
        name: 'Mexique',
    },
    {
        isoCode: 'MD',
        name: 'Moldavie',
    },
    {
        isoCode: 'MC',
        name: 'Monaco',
    },
    {
        isoCode: 'MN',
        name: 'Mongolie',
    },
    {
        isoCode: 'ME',
        name: 'Monténégro',
    },
    {
        isoCode: 'MS',
        name: 'Montserrat',
    },
    {
        isoCode: 'MZ',
        name: 'Mozambique',
    },
    {
        isoCode: 'MM',
        name: 'Myanmar (Birmanie)',
    },
    {
        isoCode: 'NA',
        name: 'Namibie',
    },
    {
        isoCode: 'NR',
        name: 'Nauru',
    },
    {
        isoCode: 'NP',
        name: 'Népal',
    },
    {
        isoCode: 'NI',
        name: 'Nicaragua',
    },
    {
        isoCode: 'NE',
        name: 'Niger',
    },
    {
        isoCode: 'NG',
        name: 'Nigeria',
    },
    {
        isoCode: 'NU',
        name: 'Niue',
    },
    {
        isoCode: 'NO',
        name: 'Norvège',
    },
    {
        isoCode: 'NC',
        name: 'Nouvelle-Calédonie',
    },
    {
        isoCode: 'NZ',
        name: 'Nouvelle-Zélande',
    },
    {
        isoCode: 'OM',
        name: 'Oman',
    },
    {
        isoCode: 'UG',
        name: 'Ouganda',
    },
    {
        isoCode: 'UZ',
        name: 'Ouzbékistan',
    },
    {
        isoCode: 'PK',
        name: 'Pakistan',
    },
    {
        isoCode: 'PA',
        name: 'Panama',
    },
    {
        isoCode: 'PG',
        name: 'Papouasie-Nouvelle-Guinée',
    },
    {
        isoCode: 'PY',
        name: 'Paraguay',
    },
    {
        isoCode: 'NL',
        name: 'Pays-Bas',
    },
    {
        isoCode: 'BQ',
        name: 'Pays-Bas caribéens',
    },
    {
        isoCode: 'PE',
        name: 'Pérou',
    },
    {
        isoCode: 'PH',
        name: 'Philippines',
    },
    {
        isoCode: 'PL',
        name: 'Pologne',
    },
    {
        isoCode: 'PF',
        name: 'Polynésie française',
    },
    {
        isoCode: 'PT',
        name: 'Portugal',
    },
    {
        isoCode: 'QA',
        name: 'Qatar',
    },
    {
        isoCode: 'HK',
        name: 'R.A.S. chinoise de Hong Kong',
    },
    {
        isoCode: 'MO',
        name: 'R.A.S. chinoise de Macao',
    },
    {
        isoCode: 'CF',
        name: 'République centrafricaine',
    },
    {
        isoCode: 'DO',
        name: 'République dominicaine',
    },
    {
        isoCode: 'RO',
        name: 'Roumanie',
    },
    {
        isoCode: 'GB',
        name: 'Royaume-Uni',
    },
    {
        isoCode: 'RW',
        name: 'Rwanda',
    },
    {
        isoCode: 'EH',
        name: 'Sahara occidental',
    },
    {
        isoCode: 'BL',
        name: 'Saint-Barthélemy',
    },
    {
        isoCode: 'KN',
        name: 'Saint-Christophe-et-Niévès',
    },
    {
        isoCode: 'SM',
        name: 'Saint-Marin',
    },
    {
        isoCode: 'MF',
        name: 'Saint-Martin',
    },
    {
        isoCode: 'SX',
        name: 'Saint-Martin (partie néerlandaise)',
    },
    {
        isoCode: 'PM',
        name: 'Saint-Pierre-et-Miquelon',
    },
    {
        isoCode: 'VC',
        name: 'Saint-Vincent-et-les Grenadines',
    },
    {
        isoCode: 'SH',
        name: 'Sainte-Hélène',
    },
    {
        isoCode: 'LC',
        name: 'Sainte-Lucie',
    },
    {
        isoCode: 'SV',
        name: 'Salvador',
    },
    {
        isoCode: 'WS',
        name: 'Samoa',
    },
    {
        isoCode: 'ST',
        name: 'Sao Tomé-et-Principe',
    },
    {
        isoCode: 'SN',
        name: 'Sénégal',
    },
    {
        isoCode: 'RS',
        name: 'Serbie',
    },
    {
        isoCode: 'SC',
        name: 'Seychelles',
    },
    {
        isoCode: 'SL',
        name: 'Sierra Leone',
    },
    {
        isoCode: 'SG',
        name: 'Singapour',
    },
    {
        isoCode: 'SK',
        name: 'Slovaquie',
    },
    {
        isoCode: 'SI',
        name: 'Slovénie',
    },
    {
        isoCode: 'SO',
        name: 'Somalie',
    },
    {
        isoCode: 'SD',
        name: 'Soudan',
    },
    {
        isoCode: 'SS',
        name: 'Soudan du Sud',
    },
    {
        isoCode: 'LK',
        name: 'Sri Lanka',
    },
    {
        isoCode: 'SE',
        name: 'Suède',
    },
    {
        isoCode: 'CH',
        name: 'Suisse',
    },
    {
        isoCode: 'SR',
        name: 'Suriname',
    },
    {
        isoCode: 'SJ',
        name: 'Svalbard et Jan Mayen',
    },
    {
        isoCode: 'TJ',
        name: 'Tadjikistan',
    },
    {
        isoCode: 'TW',
        name: 'Taïwan',
    },
    {
        isoCode: 'TZ',
        name: 'Tanzanie',
    },
    {
        isoCode: 'TD',
        name: 'Tchad',
    },
    {
        isoCode: 'CZ',
        name: 'Tchéquie',
    },
    {
        isoCode: 'TF',
        name: 'Terres australes françaises',
    },
    {
        isoCode: 'IO',
        name: 'Territoire britannique de l’océan Indien',
    },
    {
        isoCode: 'PS',
        name: 'Territoires palestiniens',
    },
    {
        isoCode: 'TH',
        name: 'Thaïlande',
    },
    {
        isoCode: 'TL',
        name: 'Timor oriental',
    },
    {
        isoCode: 'TG',
        name: 'Togo',
    },
    {
        isoCode: 'TK',
        name: 'Tokelau',
    },
    {
        isoCode: 'TO',
        name: 'Tonga',
    },
    {
        isoCode: 'TT',
        name: 'Trinité-et-Tobago',
    },
    {
        isoCode: 'TA',
        name: 'Tristan da Cunha',
    },
    {
        isoCode: 'TN',
        name: 'Tunisie',
    },
    {
        isoCode: 'TM',
        name: 'Turkménistan',
    },
    {
        isoCode: 'TR',
        name: 'Turquie',
    },
    {
        isoCode: 'TV',
        name: 'Tuvalu',
    },
    {
        isoCode: 'UA',
        name: 'Ukraine',
    },
    {
        isoCode: 'UY',
        name: 'Uruguay',
    },
    {
        isoCode: 'VU',
        name: 'Vanuatu',
    },
    {
        isoCode: 'VE',
        name: 'Venezuela',
    },
    {
        isoCode: 'VN',
        name: 'Viêt Nam',
    },
    {
        isoCode: 'WF',
        name: 'Wallis-et-Futuna',
    },
    {
        isoCode: 'YE',
        name: 'Yémen',
    },
    {
        isoCode: 'ZM',
        name: 'Zambie',
    },
    {
        isoCode: 'ZW',
        name: 'Zimbabwe',
    },
    {
        isoCode: 'AC',
        name: 'Île de l’Ascension',
    },
]

export default countries
